import { Component, Input } from '@angular/core';
import { API_STATUS_CLASSES, SupplierApiStatus, TICKET_STATUS_LABELS } from '../../../supplier-api-tester.models';

/** Statut API traduit en français, avec la valeur brute en infobulle. */
@Component({
  selector: 'vex-api-tester-status',
  template: `
    <span
      class="px-2 py-1 rounded text-xs font-medium whitespace-nowrap"
      [ngClass]="classes[status]"
      [matTooltip]="'apiStatus : ' + status"
    >
      {{ labels[status] ?? status }}
    </span>
  `,
})
export class ApiTesterStatusComponent {
  @Input() status: SupplierApiStatus;
  @Input() labels: Record<SupplierApiStatus, string> = TICKET_STATUS_LABELS;

  readonly classes = API_STATUS_CLASSES;
}
